import { h } from 'preact'
import { PureComponent } from 'preact-compat'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../modal'
import Button from '../../../control-components/ui-components/Button'
import Phrase from '../../../libs/translationsUtils/phrase'

interface Props {
  onIUnderstand: () => void
}

class PrivateMessageReportedModal extends PureComponent<Props> {
  render ({ onIUnderstand }: Props) {
    return (
      <Modal isOpen size='medium'>
        <ModalHeader title={<Phrase p='privateMessages.reportSuccessModal.title' />} onClose={onIUnderstand} />
        <ModalBody>
          <Phrase p='privateMessages.reportSuccessModal.text' />
        </ModalBody>
        <ModalFooter>
          <Button onClick={onIUnderstand}><Phrase p='privateMessages.reportSuccessModal.button' /></Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default PrivateMessageReportedModal
